import { getDefaultVideoEncodingsParameters } from "gather-video-common/dist/src/public/settings";
import { gatherVideoClientDataSource } from "./Globals";
const getRoutersFromENV = () => {
    const routers = (process.env.ROUTER_URLS ?? "")
        .split(",")
        .map((url) => url.trim())
        .filter((url) => url.length > 0);
    if (routers.length === 0)
        return null;
    return routers;
};
const envRouters = getRoutersFromENV();
const prodRouters = [...(envRouters ?? []), "wss://router.gather.town"];
const stagingRouters = envRouters ?? [
    "wss://dev-router-001.gather.town",
    "wss://dev-router-002.gather.town",
    "wss://dev-router-003.gather.town",
    "wss://dev-router-004.gather.town",
    "wss://dev-router-005.gather.town",
];
function isConfigKey(key, configs) {
    return key in configs;
}
const productionConfig = {
    environment: "prod",
    metricsOutput: "newrelic",
    metricsSampleRate: 100,
    metricsUploadRateMS: 30000,
    routerURLs: prodRouters,
    exposeManagers: false,
    minDistanceForTurn: process.env.MIN_DISTANCE_FOR_TURN
        ? parseInt(process.env.MIN_DISTANCE_FOR_TURN)
        : 6500,
};
const stagingConfig = {
    ...productionConfig,
    environment: "staging",
    metricsSampleRate: 10,
    exposeManagers: true,
    routerURLs: stagingRouters,
};
const devConfig = {
    ...productionConfig,
    environment: "dev",
    metricsOutput: "console",
    metricsSampleRate: 1,
    routerURLs: process.env.ROUTER_URL ? [process.env.ROUTER_URL] : stagingRouters,
    exposeManagers: true,
};
const localConfig = {
    ...devConfig,
    environment: "local",
};
const testConfig = {
    ...devConfig,
};
const videoClientConfigs = {
    prod: productionConfig,
    staging: stagingConfig,
    dev: devConfig,
    local: localConfig,
    test: testConfig,
};
const env = process.env.ENVIRONMENT;
if (!env)
    throw Error("no value set for ENVIRONMENT");
if (!isConfigKey(env, videoClientConfigs))
    throw Error(`invalid ENVIRONMENT value: ${env}`);
export const config = videoClientConfigs[env];
export const allConfig = videoClientConfigs;
export const getScreenShareMaxBitrate = (screenShareHighQuality) => screenShareHighQuality ? 4000000 : 1500000;
export const AUDIO_MAX_BITRATE = 24000;
export const getProducerConfig = (kind, track, screenShareHighQuality, captureResolution) => {
    const commonOptions = {
        track,
        stopTracks: false,
    };
    switch (kind) {
        case "audio":
            return {
                ...commonOptions,
                encodings: [{ dtx: true, maxBitrate: AUDIO_MAX_BITRATE }],
                codecOptions: {
                    opusDtx: true,
                    opusNack: true,
                    opusFec: true,
                    opusStereo: false,
                },
            };
        case "video":
            return {
                ...commonOptions,
                encodings: gatherVideoClientDataSource.getVideoEncodingParameters?.() ??
                    getDefaultVideoEncodingsParameters(captureResolution.width, captureResolution.height),
            };
        case "screen":
            return {
                ...commonOptions,
                encodings: [
                    Object.assign({ dtx: true }, {
                        maxBitrate: getScreenShareMaxBitrate(screenShareHighQuality),
                        scalabilityMode: "L1T1",
                    }),
                ],
            };
        case "sound":
            return {
                ...commonOptions,
                encodings: [{ dtx: true, maxBitrate: 32000 }],
                codecOptions: {
                    opusDtx: true,
                    opusNack: true,
                    opusFec: true,
                },
            };
    }
};
//# sourceMappingURL=config.js.map